import RestService from '../services/rest';

async function getInvoiceDetails(invoiceNumber, clientId) {
  return RestService.getAuthenticated(`invoice/details?number=${invoiceNumber}&client=${clientId}`);
}

export default {
  getInvoiceDetails,
};
